import { createContext, useContext } from "react";
import { RcChatMessage, RcPendingConfirmation } from "./rcTypes";

export type RcContextValue = {
  open: boolean;
  setOpen: (open: boolean) => void;
  messages: RcChatMessage[];
  listening: boolean;
  thinking: boolean;
  interim: string;
  speechError: string | null;
  speechSupported: boolean;
  pendingConfirmations: RcPendingConfirmation[];
  toggleListen: () => void;
  sendText: (text: string) => Promise<void>;
  confirm: (token: string) => Promise<void>;
  cancelConfirm: (token: string) => Promise<void>;
  clearSpeechError: () => void;
};

export const RcContext = createContext<RcContextValue | null>(null);

export function useRc(): RcContextValue {
  const ctx = useContext(RcContext);
  if (!ctx) {
    throw new Error("useRc must be used within RcProvider");
  }
  return ctx;
}
